import { LabelingArticleConversionDataManager } from '../../../manager/labeling-article-conversion-data.manager';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUtils } from '@article/util/article-utils';
import { TextureAreaVO } from '@shared/vo/meta-element.vo';
import { LabelEditorMode } from '../../../../label/label-editor/label-editor.component';
import { BaseDynamicLabelingArticleConnectProcessor } from './base-dynamic-labeling-article-connect.processor';
import { LabelEditorStateManager } from '../../../../label/label-editor/service/label-editor-state.manager';
import { Injectable } from '@angular/core';
import { AcceptingConnectionSortGroupHelper } from '@3d-scene/helper/connection/accepting-connection-sort-group.helper';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';
import { ArticleManager } from '@article/manager/article.manager';
import { CompositeArticleCacheManager } from '@article/manager/composite-article-cache.manager';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { CreateLabelingHelper } from '@project/components/label/helper/create-labeling.helper';
import { LabelingArticleRotationHelper } from '@project/components/label/helper/labeling-article-rotation.helper';
import { ProjectModel } from '@project/model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { OverlayService } from '@shared/overlay/overlay.service';
import { OpenLabelEditorService } from '../../../../label/label-editor/service/open-label-editor.service';
import { ArticleChangedService } from '@3d-scene/service/article-changed.service';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '../../../service/selection-model.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ProjectHelper } from '@project/helper/project.helper';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ArticleContainerService } from '@3d-scene/service/article-container.service';
import { CompositeArticleInfoUtils } from '@article/util/composite-article-info-utils';
import { ArticleUsageService } from '@article/service/article-usage.service';

@Injectable({ providedIn: 'root' })
export class DynamicLabelingArticleConnectProcessor extends BaseDynamicLabelingArticleConnectProcessor {
  constructor(
    projectModel: ProjectModel,
    projectModelService: ProjectModelService,
    projectArticleService: ProjectArticleService,
    projectMetaElementService: ProjectMetaElementService,
    localeResourceManager: LocaleResourceManager,
    articleContainerLoader: ArticleContainerLoader,
    compositeArticleCacheManager: CompositeArticleCacheManager,
    articleContainerFactory: ArticleContainerFactory,
    articleManager: ArticleManager,
    compositeArticleUtils: CompositeArticleUtils,
    compositeArticleInfoUtils: CompositeArticleInfoUtils,
    articleContainerUtils: ArticleContainerUtils,
    acceptingConnectionSortGroupHelper: AcceptingConnectionSortGroupHelper,
    containerService: ContainerService,
    projectHelper:ProjectHelper,
    alertHelper: AlertHelper,
    createLabelingHelper: CreateLabelingHelper,
    overlayService: OverlayService,
    labelingArticleRotationHelper: LabelingArticleRotationHelper,
    labelingUtils: LabelingUtils,
    articleChangedService: ArticleChangedService,
    detachArticleUsageService: DetachArticleUsageService,
    private dataManager: LabelingArticleConversionDataManager,
    private selectionModelService: SelectionModelService,
    private labelEditorStateManager: LabelEditorStateManager,
    private openLabelEditorService: OpenLabelEditorService,
    articleContainerService: ArticleContainerService,
    articleUsageService: ArticleUsageService,
  ) {
    super(
      projectModel,
      projectModelService,
      projectArticleService,
      projectMetaElementService,
      localeResourceManager,
      articleContainerLoader,
      compositeArticleCacheManager,
      articleContainerFactory,
      articleManager,
      compositeArticleUtils,
      compositeArticleInfoUtils,
      articleContainerUtils,
      acceptingConnectionSortGroupHelper,
      containerService,
      articleChangedService,
      detachArticleUsageService,
      projectHelper,
      alertHelper,
      createLabelingHelper,
      overlayService,
      labelingArticleRotationHelper,
      labelingUtils,
      articleContainerService,
      articleUsageService,
    );
  }

  public postProcess(containers: ArticleContainer[]): void {
    if (!this.dataManager.isConverting) {
      if (this.dataManager.stopPostProcess) {
        return;
      }
      this.selectionModelService.selectArticlesByUsageIds(containers.map((c) => c.articleUsage.id));
      if (this.labelEditorStateManager.labelEditorMode === LabelEditorMode.CLOSED) {
        const textureConnections: Connection[] = [];
        for (const articleContainer of containers) {
          const textureMetaElements: TextureAreaVO[] = ArticleUtils.getTextureElements(articleContainer.article);
          for (const textureArea of textureMetaElements) {
            const cube: Connection = articleContainer.findFirstConnectionByName(textureArea.name);
            if (cube) {
              textureConnections.push(cube);
            }
          }
        }
        this.openLabelEditorService.openForData({
          connectionCubes: textureConnections,
          validateSizes: this._validateSizes,
          selectAllCellsOnInit: false,
        });
      }
      this._validateSizes = true;
    } else {
      this.dataManager.applyDataToContainers(containers);
    }
  }
}
